import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-edit-market",
  templateUrl: "./edit-market.component.html",
  styleUrls: ["./edit-market.component.scss"],
})
export class EditMarketComponent implements OnInit {
  addMarketForm: FormGroup;
  marketTypeList: string[] = ["Match Odds", "Book Maker", "Fancy", "Premium"];
  selectedProvider;
  gamesList: [];
  tablesList: [];
  eventName: string;
  eventId: string;
  ProviderId: string = "";
  OperatorId: string = "";
  competitionId: string = "";
  sportId: string = "all";
  marketData;
  runnerNames: string[] = [];
  MARKET_TYPES = ["MATCH_ODDS", "BOOKMAKER"];
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private appService: AppService,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.OperatorId = this.route.snapshot.params.operator;
    this.ProviderId = this.route.snapshot.params.provider;
    this.sportId = this.route.snapshot.params.sport;
    this.competitionId = this.route.snapshot.params.competition;
    this.eventId = this.route.snapshot.params.eventId;
    this.eventName = this.route.snapshot.params.eventName;
    console.log(this.ProviderId,this.sportId,this.competitionId,this.eventId,this.eventName)
    this.intializeAddMarketForm();
    this.getOurMarket(this.ProviderId, this.sportId, this.eventId);
  }

  getOurProviders() {
    try {
      this.appService.getOurProviders().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.marketTypeList = res.providers;
          // console.log(this.providersList);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  intializeAddMarketForm() {
    this.addMarketForm = this.fb.group({
      eventName: [this.eventName, Validators.required],
      eventId: [this.eventId, Validators.required],
      markets: this.fb.array([]),
    });
    this.addMarket();
  }

  onChangeMarketType() {
    let pid = this.addMarketForm.controls["marketType"].value;
    this.tablesList = [];
    this.getGameData(pid);
  }

  onChangeGame() {
    let pid = this.addMarketForm.controls["providerId"].value;
    let gid = this.addMarketForm.controls["eventName"].value;
    this.getOurTable(pid, gid);
  }

  getGameData = (pid) => {
    try {
      // this.appService.getGameData(pid).subscribe((res) => {
      //   if (res.status === "RS_OK") {
      //     this.gamesList = res.games;
      //   }
      // });
    } catch (err) {}
  };

  getOurTable = (pid, sid) => {
    try {
      // this.appService.getTableData(pid, sid).subscribe((res) => {
      //   if (res.status === "RS_OK") {
      //     this.tablesList = res.Table;
      //   }
      // });
    } catch (err) {}
  };

  get markets() {
    return this.addMarketForm.controls["markets"] as FormArray;
  }

  get runners() {
    return this.addMarketForm.controls["markets.runners"] as FormArray;
  }

  get backPrices() {
    return this.addMarketForm.controls[
      "markets.runners.backPrices"
    ] as FormArray;
  }

  get layPrices() {
    return this.addMarketForm.controls[
      "markets.runners.layPrices"
    ] as FormArray;
  }

  addMarket() {
    const marketForm = this.fb.group({
      marketId: [this.appService.getMarket().MarketId, Validators.required],
      marketName: [this.appService.getMarket().MarketName, Validators.required],
      marketType: [this.appService.getMarket().MarketType, Validators.required],
      // marketStatus: [this.appService.getMarket().MarketStatus, Validators.required],
      runners: this.fb.array([]),
    });
    // console.log(this.markets);
    this.markets.push(marketForm);
    this.appService.getMarket().Runners.forEach((runner, i) => {
      this.addRunner(marketForm, i);
    });
  }

  addRunner(market, i = 0) {
    console.log("runner",this.appService.getMarket().Runners[i].RunnerName)
    const runnerForm = this.fb.group({
      runnerId: [
        this.appService.getMarket().Runners[i].RunnerId,
        Validators.required,
      ],
      runnerName: [
        this.appService.getMarket().Runners[i].RunnerName,
        Validators.required,
      ],
      // runnerType: ["", Validators.required],
      backPrices: this.fb.array([]),
      layPrices: this.fb.array([]),
    });
    market.get("runners").push(runnerForm);
    this.addBackPrices(runnerForm);
    this.addLayPrices(runnerForm);
  }

  addBackPrices(runner) {
    const backPricesForm = this.fb.group({
      price: ["", Validators.required],
      size: ["", Validators.required],
    });
    runner.get("backPrices").push(backPricesForm);
  }

  addLayPrices(runner) {
    const layPricesForm = this.fb.group({
      price: ["", Validators.required],
      size: ["", Validators.required],
    });
    runner.get("layPrices").push(layPricesForm);
  }

  deleteMarket(marketIndex: number) {
    this.markets.removeAt(marketIndex);
  }

  deleteRunner(market, runnerIndex: number) {
    market.get("runners").removeAt(runnerIndex);
  }

  deleteBackPrices(runner, backPricesIndex: number) {
    runner.get("backPrices").removeAt(backPricesIndex);
  }

  deleteLayPrices(runner, layPricesIndex: number) {
    runner.get("layPrices").removeAt(layPricesIndex);
  }

  onFormSubmit() {
    const keys = Object.keys(this.addMarketForm.value);
    // console.log(keys)
    let data = this.addMarketForm.value;
    // console.log(data);
    keys.forEach((key: string) => {
      // console.log(key);
      // if(keys === '')
      data[key] = this.addMarketForm.value[key];
    });
    let newData = {
      competitionId: this.competitionId,
      competitionName: this.appService.getCompetition().CompetitionName,
      eventId: this.eventId,
      eventName: this.eventName,
      providerId: this.ProviderId,
      providerName: this.appService.getProvider().ProviderName,
      sportId: this.sportId,
      sportName: this.appService.getSport().SportName,
      status: "ACTIVE",
      ...data.markets[0],
    };
    console.log("data", newData);

    this.appService.updateMarket(newData).subscribe(
      (res) => {
        if (res.errorDescription === "") {
          // this.router.navigateByUrl("administration/market");
          this.location.back();
          this.appService.openSuccessBar("Market added successfully");
        }
        if (res.errorDescription !== "") {
          this.appService.openErrorBar(res.errorDescription);
        }
        // console.log(res);
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  get IsValid() {
    if (this.addMarketForm.invalid) {
      return true;
    }
    //form valid
    if (this.addMarketForm.controls.markets.value.length !== 0) {
      let count = 0;
      this.addMarketForm.get("markets")["controls"].forEach((market) => {
        if (market.get("runners").value.length !== 0) {
          count = count + 1;
        }
      });
      if (count === this.addMarketForm.controls.markets.value.length) {
        let countRunner = 0,
          countValidRunner = 0;
        this.addMarketForm.get("markets")["controls"].forEach((market) => {
          market.get("runners")["controls"].forEach((runner) => {
            countRunner = countRunner + 1;
            if (runner.get("backPrices").value.length !== 0) {
              countValidRunner = countValidRunner + 1;
            }
          });
        });
        if (countRunner === countValidRunner) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  redirectMarketManagementPage() {
    // this.router.navigateByUrl("administration/market");
    this.location.back();
  }

  getOurMarket = (pid, sid, eid) => {
    try {
      this.appService
        .getMarketCatalogData(this.OperatorId, pid, sid, eid)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.marketData = res.markets ? res.markets : res.marketStatus;
            this.getRunners();
          }
        });
    } catch (err) {}
  };

  getRunners() {
    this.marketData = this.marketData.filter((market) => {
      return this.MARKET_TYPES.includes(market.MarketType);
    });

    let runners: any[] = [];

    this.marketData.forEach((market) => {
      runners = runners.concat(market.Runners);
    });

    runners.forEach((runner) => {
      if (!this.runnerNames.includes(runner.RunnerName)) {
        this.runnerNames.push(runner.RunnerName);
      }
    });
    // console.log("runnerNames",this.runnerNames)
  }
}
